import React, { Fragment, useContext } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";

import OverallBalance from "./OverallBalance";
import GreetingCard from "./GreetingCard";
import WidgetsWrapper from "./WidgetsWraper";
import RecentOrders from "./RecentOrders";
import ActivityCard from "./ActivityCard";
import RecentSales from "./RecentSales";
import TimelineCard from "./TimelineCard";
import TotalUserAndFollower from "./TotalUserAndFollower";
import PaperNote from "./PaperNote";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CustomizerContext from "../../../_helper/Customizer";
import axios from "axios";
import config from "../../../config";
import { toast } from "react-toastify";

const Dashboard = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  // const islogin = localStorage.getItem("login");
  // console.log(islogin);
  // if (islogin !== true) {
  //   history(`${process.env.PUBLIC_URL}/login`);
  // }
  const token = localStorage.getItem("sessiontoken");
  const configheader = {
    headers: {
      Authorization: `${token}`
    }
  };

  const userType = localStorage.getItem("usertype")
  const userTypeId = localStorage.getItem("usertypeId")

  if (userType === "admin") { //admin
    localStorage.setItem("accessDashboard", "1")
    localStorage.setItem("accessAnalytics", "1")
    localStorage.setItem("accessReports", "1")
    localStorage.setItem("accessDataGrid", "1")
    localStorage.setItem("accessGeneralSettings", "1")
    localStorage.setItem("manageGeneralSettings", "1")
    localStorage.setItem("accessTenants", "1")
    localStorage.setItem("manageTenants", "1")
    localStorage.setItem("manageConfigurations", "1")
    localStorage.setItem("manageUsers", "1")
    localStorage.setItem("manageUserProfile", "1")
    localStorage.setItem("accessLogs", "1")
    localStorage.setItem("manageScheduleReports", "1")
    localStorage.setItem("tenantPortalManage", "1")
    localStorage.setItem("manageLeaseDetails", "1")
    history(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`); //admin

  }
  else if (userType === "sadmin") {
    history(`${process.env.PUBLIC_URL}/controlpanel/dashboard/default/${layoutURL}`)   //super admin
  }
  else if (userType === "tenant") {
    history(`${process.env.PUBLIC_URL}/tenant/home/${layoutURL}`)  //Tenant
  }
  else if (userType === "Backend User") {
    history(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`); //selected concessionaire's dashboard
  }
  else {
    axios.post(`${config.hostname}/userpermissions/getpermissionbyusertype`, { user_type_id: userTypeId }, configheader)
      .then((response) => {
        localStorage.setItem("accessDashboard", response.data[0].access_dashboard)
        localStorage.setItem("accessAnalytics", response.data[0].access_analytics)
        localStorage.setItem("accessReports", response.data[0].access_report)
        localStorage.setItem("accessDataGrid", response.data[0].access_data_grid)
        localStorage.setItem("accessGeneralSettings", response.data[0].acess_general_settings)
        localStorage.setItem("manageGeneralSettings", response.data[0].manage_general_settings)
        localStorage.setItem("accessTenants", response.data[0].access_tenants)
        localStorage.setItem("manageTenants", response.data[0].manage_tenants)
        localStorage.setItem("manageConfigurations", response.data[0].manage_configurations)
        localStorage.setItem("manageUsers", response.data[0].manage_users)
        localStorage.setItem("manageUserProfile", response.data[0].manage_user_profile)
        localStorage.setItem("accessLogs", response.data[0].access_logs)
        localStorage.setItem("manageScheduleReports", response.data[0].manage_schedule_reports)
        localStorage.setItem("tenantPortalManage", response.data[0].manual_portal_access)
        localStorage.setItem("manageLeaseDetails", response.data[0].manage_lease_details)

        history(`${process.env.PUBLIC_URL}/admin/dashboard/sales/${layoutURL}`);    //admin users
      })
      .catch((error) => {
        console.log(error);
        toast.error(t("error on fetching permissions"));
      });

  }

  return (
    <Fragment>
      <Breadcrumbs mainTitle={t('Default')} parent={t('Dashboard')} title={t('Default')} />
      <Container fluid={true}>
        <Row className="widget-grid">
          <GreetingCard />
          <WidgetsWrapper />
          <OverallBalance />
          <RecentOrders />
          <ActivityCard />
          <RecentSales />
          <TimelineCard />
          <TotalUserAndFollower />
          <PaperNote />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Dashboard;
